// ======================================================================
// 📁 File: src/modules/ppe/components/material/raw-material/RawMaterialKpiBar.jsx
// 📝 Purpose:
//   KPI Bar for Raw Material Master
//   - Total / Active / Inactive
//   - Used in BOQ
//   - BOQ-ready & future-safe
// ======================================================================

import React, { useMemo } from "react";

// ------------------------------------------------------------------
// KPI Card (shared visual language across PPE masters)
// ------------------------------------------------------------------
const KpiCard = ({ title, value, color }) => (
  <div
    style={{
      flex: 1,
      minWidth: 160,
      background: "#fff",
      borderRadius: 12,
      padding: "14px 16px",
      boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
      display: "flex",
      alignItems: "center",
      gap: 12,
    }}
  >
    {/* Vertical Accent */}
    <div
      style={{
        width: 4,
        height: "100%",
        background: color,
        borderRadius: 4,
      }}
    />

    <div>
      <div style={{ fontSize: 12, color: "#6b7280" }}>{title}</div>
      <div
        style={{
          fontSize: 22,
          fontWeight: 600,
          color: "#111827",
          lineHeight: 1.2,
        }}
      >
        {value}
      </div>
    </div>
  </div>
);

// ------------------------------------------------------------------
// KPI Bar
// ------------------------------------------------------------------
export default function RawMaterialKpiBar({ rows = [] }) {
  const kpis = useMemo(() => {
    const total = rows.length;

    const active = rows.filter(
      (r) => r.is_active === 1 || r.is_active === true
    ).length;

    const inactive = rows.filter(
      (r) => r.is_active === 0 || r.is_active === false
    ).length;

    const usedInBoq = rows.filter(
      (r) => r.used_in_boq === true || r.used_in_boq === 1
    ).length;

    return {
      total,
      active,
      inactive,
      usedInBoq,
    };
  }, [rows]);

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
        flexWrap: "wrap",
      }}
    >
      <KpiCard title="Total Materials" value={kpis.total} color="#6366f1" />
      <KpiCard title="Active" value={kpis.active} color="#16a34a" />
      <KpiCard title="Inactive" value={kpis.inactive} color="#9ca3af" />
      <KpiCard title="Used in BOQ" value={kpis.usedInBoq} color="#f59e0b" />
    </div>
  );
}
